import React from "react";
import { Link } from "react-router-dom";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Link
    to=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="header-link"
  >
    {children}
  </Link>
));

CustomToggle.displayName = "CustomToggle";

export default CustomToggle;
